<template>
	<div>
		<modal v-if="isOpen" :size="'md'" @close="close">
			<div slot="body" >

				<div class="text-center" v-html="t('popup.bet-cancel.content')">

				</div>
				<div class="row">
					<div class="col-12 mt-5">
						<table class="table table-striped account__table account__table--bets account__table--complex account__table--mobile">
							<thead class="thead-dark" v-if="!isMobile">
							<tr>
								<th scope="col">{{ t('user.page.table.bets.id') }}</th>
								<th scope="col">{{ t('user.page.table.bets.date') }}</th>
								<th scope="col">{{ t('user.page.table.bets.race') }}</th>
								<th scope="col">{{ t('user.page.table.bets.bettype') }}</th>
								<th scope="col">{{ t('user.page.table.bets.bet') }}</th>
								<th scope="col">{{ t('user.page.table.bets.benefit') }}</th>
								<th scope="col">{{ t('user.page.table.bets.status') }}</th>
								<th scope="col">{{ t('user.page.table.bets.formula') }}</th>
							</tr>
							</thead>
							<tbody>
							<tr class="cancel-one-row">
								<th scope="row" :data-title="t('user.page.table.bets.id')">
									{{bet.id}}
								</th>
								<td v-html="betDateString(bet.created)" :data-title="t('user.page.table.bets.date')"></td>
								<td :data-title="t('user.page.table.bets.race')">
									{{ bet.trackname }}
								</td>
								<td :data-title="t('user.page.table.bets.bettype')">
									<span class="game game--iconed" :class="'game--'+snakeCase(bet.wagetype)">{{ bet.wagetype}}</span>
								</td>
								<td :data-title="t('user.page.table.bets.bet')">
									{{formatToMoney(bet.totalamount)}}
								</td>
								<td :data-title="t('user.page.table.bets.benefit')">{{formatToMoney(bet.winamount)}}</td>
								<td :data-title="t('user.page.table.bets.status')">{{t('bet.status.'+bet.status)}}</td>
								<td :data-title="t('user.page.table.bets.formula')">{{bet.leg}}</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>

				<form-message :messages="getMessage('bet-cancel')"></form-message>
			</div>
			<div class="row justify-content-center" slot="footer">
				<div class="col-6 d-flex justify-content-center">
					<button @click="close" class="btn btn-secondary" :disabled="isLoading">
						{{ t('popup.bet-cancel.btn.cancel')}}
					</button>
				</div>
				<div class="col-6 d-flex justify-content-center">
					<button class="btn btn-primary btn-sm" @click="submitBetCancel" :disabled="isLoading">
						<loader v-if="isLoading" :size="20" :color="'white'"></loader> {{ t('popup.bet-cancel.btn.submit')}}
					</button>
				</div>
			</div>
		</modal>
	</div>
</template>
<script>

	import Modal from '@/components/parts/modal';
	import FormMessage from '@/components/parts/form-message';
	import {instance, bettingApi} from '@/api';
	import moment from 'moment-timezone';

	export default {
		name: 'bet-cancel-modal',
		props: [ 'bet'],
		components:{
			'modal': Modal,
			'form-message': FormMessage
		},
		data() {
			return {
				cancelModal: false,
				name: 'bet-cancel-modal'

			}
		},
		computed:{

			isOpen(){

				return this.bet !== null;
			},
			isLoading(){
				return this.$store.state.loaderList.some( el => el === this.name);
			}
		},
		watch:{
			bet(){
				this.deleteMessage('bet-cancel');

			}
		},
		mounted(){
			this.deleteMessage('bet-cancel');

		},
		methods: {
			close(){
				this.$emit('close');
			},
			submitBetCancel(){
				if(!this.isLoading){
					this.deleteMessage('bet-cancel');

					this.addLoad(this.name);

					instance.post(bettingApi.cancel+this.bet.id).then((response)=>{

						if(response.data.status === 'SUCCESS'){
							this.$emit('update');
							this.$emit('close');
						}

						let msg;
						if(typeof response.data.message !== 'undefined'){
							msg = response.data.message;
						}else if(typeof response.data.error !== 'undefined'){
							msg = response.data.error;
						}
						this.restMessageHandler(response.data.status, 'bet-cancel', msg, 'bet-cancel')

					}).catch(()=>{

					}).then(()=>{
						this.endLoad(this.name);
					});
				}

			},

			betDateString(date){
				date = moment(date);

				let format = this.isSimple ? 'DD/MM' : 'DD/MM/YYYY';
				let br = this.isSimple ? '<br>' : '';

				return `${date.format(format)}
				${br}
				${this.formatToTime(date)}`;
			},
		}
	}
</script>
<style lang="scss">
	.cancel-one-row{
		background-color: transparent!important;
		th,td{
			border-top: none;
		}
	}
</style>